package com.parmartechnologies.commerce.feature.inventory.repository

import com.parmartechnologies.core.feature.inventory.coupon.model.Coupon
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

class CouponRepository {
    val couponLiveData: MutableStateFlow<List<Coupon>> = MutableStateFlow(arrayListOf())
    val allCoupon: StateFlow<List<Coupon>>
        get() = couponLiveData

    val selectedCouponState: MutableStateFlow<Coupon?> = MutableStateFlow(null)
    val selectedCoupon: StateFlow<Coupon?>
        get() = selectedCouponState

}